import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Necesito comprar los suplementos de Herbalife aparte?',
  answer: 'Sí, la guía te enseña cómo usarlos profesionalmente, pero los productos se adquieren por separado para garantizar su frescura y autenticidad.'
}, {
  question: '¿Qué pasa si ya estoy tomando otros medicamentos?',
  answer: 'Siempre recomendamos consultar con tu médico, pero este protocolo se basa en nutrición botánica natural.'
}, {
  question: '¿Es difícil de seguir?',
  answer: 'Para nada. Está diseñado para mujeres reales con vidas ocupadas. Son ajustes pequeños de 5 a 10 minutos.'
}, {
  question: '¿Cuándo veré resultados?',
  answer: 'Muchos sienten alivio en el sueño desde la segunda noche, y cambios en la energía al cuarto día.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-6 md:px-12 max-w-3xl mx-auto" data-id="element-30">
      <FadeIn data-id="element-31">
        <div className="text-center mb-12" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-warm-dark mb-4" data-id="element-33">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-rose-gold mx-auto rounded-full" data-id="element-34"></div>
        </div>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-blush rounded-2xl overflow-hidden shadow-sm" data-id="element-36">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-37">
                <span className="font-serif font-bold text-lg text-warm-dark pr-4" data-id="element-38">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0 text-copper" data-id="element-39">
                  <ChevronDown className="w-6 h-6" data-id="element-40" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-41">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-42">
                    <div className="px-6 pb-5 text-warm-dark/70 font-sans leading-relaxed" data-id="element-43">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </FadeIn>
    </section>;
}